// extracted by mini-css-extract-plugin
module.exports = {"FooterPopUp":"FooterPopUp_FooterPopUp__22eDD","FooterPopUpContent":"FooterPopUp_FooterPopUpContent__4Nkim","FooterPopUpClose":"FooterPopUp_FooterPopUpClose__1fuxQ"};